import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ISDialogStyleHandlerService {
    dialogIds: string[] = [];
    minimizedDialogs: string[] = [];

    constructor() { }

    public addDialog(id: string) {
        this.dialogIds.push(id);
        setTimeout(() => {
            this.updateZindex(id)
        }, 50);
    }

    public removeDialog(id: string) {
        let dialogIndex = this.dialogIds.findIndex(x => x == id);
        if (dialogIndex > -1) {
            this.dialogIds.splice(dialogIndex, 1);
        }
        let tabIndex = this.minimizedDialogs.findIndex(x => x == id);
        if (tabIndex > -1) {
            this.minimizedDialogs.splice(tabIndex, 1);
        }
    }

    public minimizeDialog(id: string) {
        this.minimizedDialogs.push(id);
    }

    public onMouseClick(target: any): boolean {
        let clickedOutside: boolean = true;
        if (this.dialogIds.length > 0) {
            for (const key in this.dialogIds) {
                const element = this.dialogIds[key];
                let dialog = document.getElementById(element);
                if (dialog && dialog.contains(target)) {
                    clickedOutside = false;
                }
            };
            return clickedOutside;
        }
        return false;
    }

    public minimizeAllDialogs() {
        this.dialogIds.forEach(dialogId => {
            let dialogIndex = this.minimizedDialogs.findIndex(x => x == dialogId);
            if (dialogIndex < 0) {
                this.minimizedDialogs.push(dialogId);
            }
        });
    }

    public removeMinimizeDialog(id: string) {
        let index = this.minimizedDialogs.indexOf(id);
        if (index > -1) {
            this.minimizedDialogs.splice(index, 1);
        }
    }

    public updateZindex(id: string) {
        const totalDialogs = this.dialogIds.length;
        let zIndexUpdate = 15000;
        this.dialogIds.forEach(dialogId => {
            let dialog = document.getElementById(dialogId);
            if (dialog) {
                if (dialogId == id) {
                    dialog.style.zIndex = (zIndexUpdate + totalDialogs + 2).toString();

                } else {
                    dialog.style.zIndex = zIndexUpdate.toString();
                    zIndexUpdate++;
                }
            }
        });
    }
}
